import map from "lodash/map";
import range from "lodash/range";
import round from "lodash/round";
import convert from "convert-units";

import { PARAMETER_OPTIONS } from "../../../../../../constants";
import convertToRiR from "../../../../../../utils/converters/convert-intensity";
import { repsValue } from "../../../../../../utils/reps-range";
import { getLoadDrop } from "../../../../../../utils/load-drop";

const { RPE, RPEAMRAP, LOAD, REPS } = PARAMETER_OPTIONS;

const TableForAssistant = ({
  idx,
  exercise,
  editDayMode,
  editable,
  set,
  handler,
  isTemporal,
  addTempSet,
  removeSet,
  intensityMeasure,
  isRiR,
  units,
  withWeight,
  fromMetric,
  hasLoadDrop,
}) => {
  const renderParameter = (_param) => {
    const param = _param.toLowerCase();
    if (editDayMode && editable) {
      if ([RPE, RPEAMRAP, "rpe/amrap"].includes(param)) {
        return (
          <select
            id={`rpe-${exercise._id}-${idx}`}
            className="select-input"
            name="rpe"
            value={set.rpe}
            onChange={(evt) => {
              handler({
                value: evt.target.value,
                field: "rpe",
                exerciseId: exercise._id,
                setIdx: idx,
              });
            }}
          >
            <option value="">{`${intensityMeasure}`}</option>
            {map(range(4, 9.5, 0.5), (i) => (
              <option key={i} value={i + 1}>
                {convertToRiR(i + 1, !isRiR)}
              </option>
            ))}
            <option value="AMRAP">AMRAP</option>
          </select>
        );
      } else if (_param === LOAD && hasLoadDrop) {
        return (
          <>
            <input
              className="!text-left"
              value={set.loadDrop}
              onChange={(evt) => {
                if (String(evt.target.value).includes(",")) {
                  evt.target.value = String(evt.target.value).replace(",", ".");
                }
                handler({
                  value: evt.target.value,
                  field: "loadDrop",
                  exerciseId: exercise._id,
                  setIdx: idx,
                });
              }}
            />
            <span className="units-label">% mod.</span>
          </>
        );
      } else if (_param === LOAD) {
        return (
          <>
            <input
              className="text-input"
              id={`sets-${exercise._id}-${idx}`}
              defaultValue={set[param] > 0 ? fromMetric(set[param]) : ""}
              onChange={(evt) => {
                if (String(evt.target.value).includes(",")) {
                  evt.target.value = String(evt.target.value).replace(",", ".");
                }
                if (isNaN(evt.target.value)) return;
                let value = evt.target.value;
                if (units === "imperial" && value !== "") {
                  value = round(convert(value).from("lb").to("kg"), 2);
                }
                handler({
                  value,
                  field: param,
                  exerciseId: exercise._id,
                  setIdx: `${exercise._id}-${isTemporal ? "-new" : idx}`,
                });
              }}
            />
            <span className="units-label">
              {units === "imperial" ? "lb" : "kg"}
            </span>
          </>
        );
      } else {
        return (
          <input
            className="text-input"
            id={`sets-${exercise._id}-${idx}`}
            value={set[param]}
            onChange={(evt) =>
              handler({
                value: evt.target.value,
                field: param,
                exerciseId: exercise._id,
                setIdx: `${exercise._id}-${isTemporal ? "-new" : idx}`,
              })
            }
          />
        );
      }
    } else if ([RPE, RPEAMRAP, "rpe/amrap"].includes(param)) {
      return convertToRiR(set.rpe, !isRiR);
    } else if (_param === LOAD && set.loadDrop) {
      return getLoadDrop(set.loadDrop);
    } else if (_param === LOAD && set.load > 0) {
      return withWeight(fromMetric(set.load));
    } else if (_param === REPS) {
      return repsValue(set.reps, set.repsLower);
    } else {
      return set[param];
    }
  };

  return (
    <tr key={idx}>
      {exercise &&
        exercise.parameters &&
        exercise.parameters.map((_param = "", idy) => {
          return <td key={idy}>{renderParameter(_param)}</td>;
        })}
      {exercise.sets.length && editDayMode && editable ? (
        <td className="actions">
          <button
            data-button-type="secondary"
            onClick={() => {
              addTempSet({ exerciseId: exercise._id, pos: idx });
            }}
          >
            <img
              src="/img/new-icons/add-gradient-icon.svg"
              height={24}
              width={24}
              alt="plus icon"
            />
          </button>
          <button
            data-button-type="secondary"
            onClick={() => {
              removeSet(exercise._id, idx);
            }}
          >
            <img
              src="/img/new-icons/red-trash.svg"
              height={18}
              width={18}
              alt="trash icon"
            />
          </button>
        </td>
      ) : null}
    </tr>
  );
};

export default TableForAssistant;
